export function convertStringToCompare(text = '') {
  const a = 'àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;'
  const b = 'aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------'
  const p = new RegExp(a.split('').join('|'), 'g')
  return text.toString().toLowerCase().trim()
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[\s\W-]+/g, '-') // Replace spaces, non-word characters and dashes with a single dash (-)
}

export function formatDate(date) {
  if (!date) return null;

  const dateObj = new Date(date).toISOString().substr(0, 10);
  const [year, month, day] = dateObj.split('-');
  return `${day}/${month}/${year}`;
}

export function statusColor(status = '') {
  if (status === 'Ativo') return 'success';
  else if (status === 'Inativo') return 'info';
  else if (status === 'Cancelado') return 'secondary';
  else return '';
}

export function tryParseJSON (jsonString){
  try {
      var o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object", 
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === "object") {
          return o;
      }
  } catch (e) {
    return false;
  }

  return false;
}